import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const Category = loadable(() => import('./Category'));

Category.getInitialState = getInitialState;

export default Category;
